/* eslint-disable @next/next/no-img-element */
import { isEmpty } from "lodash";
import { useEffect, useState } from "react";
import Image from 'next/image';
import ImageComponentWithTag from 'components/cong-dong/chi-tiet/imageComponentWithTag';
import {POST_TYPE_MAPPING} from "utilities/constants";

import { Modal } from "react-bootstrap";

export default function ImageComponent({ item, index=null, total=0, anhTo=false }) {
    const [imageModals, setImageModal] = useState(false);
    let user = {};
    if (!isEmpty(item.tagged_products)) {
        user = item.tagged_products[0].user;
    }
    const article = !isEmpty(item.albums?.data) ? item.albums?.data[0] : {};
    return (
        <>
            <div className="photoGallery wrap-next-image" style={{ cursor: 'pointer' }}>
                <a onClick={() => setImageModal(true)} style={{ width: '100%', paddingTop: '100%' }}>
                    <Image layout="fill" src={item.storage_url || item.storage_thumbnail_url || item.storage_thumbnail_wide_url || item.storage_medium_url } align="" alt="" style={{ objectFit: "cover" }} />
                    {!isEmpty(user) && <div className="photo-User">
                        {!anhTo && <div className="photo-name">
                            <span><Image height={18} width={18} src="/images/icon-app.svg" alt="" /></span>
                            {user?.display_name}
                        </div>}

                        {anhTo && <div className="photo-name" style={{ fontSize: 14}}>
                            <span style={{ width: 32, marginRight: 8 }}><Image height={32} width={32} src="/images/icon-app.svg" alt="" /></span>
                            {user?.display_name}
                        </div>}
                        {index != null && <div className="photo-number">{index + 1}/{total}</div>}
                    </div>}
                </a>
            </div>

            <Modal show={imageModals} size="lg" onHide={() => setImageModal(false)} role="document">
                <Modal.Header closeButton>
                    <h5 className="modal-title">Ảnh từ người dùng: {user?.display_name} {!isEmpty(article) &&
                        <>
                            <span>-</span>
                            <a className="ml-1" target="_blank" rel="noreferrer" href={`/${POST_TYPE_MAPPING[article.post_type_id]}${article.id}/${article.slug}`} style={{ color: '#34beef' }}>
                                Xem bài viết
                            </a>
                        </>}
                    </h5>
                </Modal.Header>
                <Modal.Body>
                    <div className="thumb sliderPhoto" style={{ position: 'relative' }}>
                        <ImageComponentWithTag image={item} noMarginTop={true} />
                    </div>
                </Modal.Body>
            </Modal>
        </>
    );
}